import { CreateUser2FAArgs } from 'types/api/arguments/create-user-2-fa-args'
import { CreateUser2FAResp } from 'types/api/response/create-user-2-fa-resp'

import { api } from './api'

export const createUser2FA = (args: CreateUser2FAArgs) =>
  api.post<CreateUser2FAResp>(`/users/${args.userId}/user_2fa`, {
    entity_id: args.entityId,
    type: args.entityType,
    fingerprint: args.fingerprint,
  })
